import React from 'react';
import Column from "@Containers/components/Column";
import {TransfersDataType} from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import ParamsType from "@SearchResults/types/params/Params.type";
import SearchResultsUrlsType from "@SearchResults/types/urls/SearchResultsUrls.type";
import {
    GetByFerryDataType
} from "@SearchResults/features/banners/features/getByTransferBanner/types/GetByFerryData.type";
import NoResultsNotice from "@SearchResults/features/noResults/components/NoResultsNotice";
import hasNoDirectRoutes from "@SearchResults/features/noResults/functions/hasNoDirectRoutes";
import {useIsAircash} from "@Hooks/selector/useIsAircash";
import NoDirectRoutes from "@SearchResults/features/noResults/components/NoDirectRoutes";
import NoResultsWithGbtPromo from "@SearchResults/features/noResults/components/NoResultsWithGbtPromo";
import AccommodationBanner
    from "@SearchResults/features/banners/features/accommodationBanner/components/AccommodationBanner";

interface NoResultsProps {
    getByFerryData: GetByFerryDataType,
    transfersData: TransfersDataType,
    urls: SearchResultsUrlsType,
    params: ParamsType,
}

function NoResults({urls, params, getByFerryData, transfersData}: NoResultsProps) {
    const {noDirectRoutes} = hasNoDirectRoutes(transfersData, params)
    const isAircash = useIsAircash()
    const shouldReverseNoticeLayout = Boolean(noDirectRoutes && getByFerryData)
    const shouldShowStandardNotice = !getByFerryData || !noDirectRoutes
    const shouldUseSmallTitle = Boolean(getByFerryData && !noDirectRoutes)

    return (
        <>
            <Column className="no-results__content" reverse={shouldReverseNoticeLayout}>
                {shouldShowStandardNotice ? (
                    <NoResultsNotice
                        params={params}
                        urls={urls}
                        smallTitle={shouldUseSmallTitle}
                    />
                ) : (
                    <NoDirectRoutes
                        toCityName={transfersData?.toName ?? ""}
                        nearByCityName={noDirectRoutes ? transfersData?.departureNearbyCity?.name : ""}
                    />
                )}
            </Column>
            {!isAircash && (
                <AccommodationBanner
                    params={params}
                />
            )}
            {!isAircash && (
                <NoResultsWithGbtPromo
                    transfersData={transfersData}
                />
            )}
        </>
    );
}

export default NoResults;
